<!--
 * @Description: 流程审批代理
 * @Autor: lwq
 * @Date: 2020-07-29 09:31:57
 * @LastEditors: yd
 * @LastEditTime: 2020-12-08 17:36:28
 * @FilePath: \mrc-base-server-view\src\views\approver\index.vue
-->
<template>
  <div>
    <!--  -->
    <mrc_ess_table :headers="headers" v-if="$route.name == 'approvertype'" pageName="addApprovertype"
      :hideAddBtn="!hasBtn('add-approval-business-type')" :paginationOptions="paginationOptions" @turnPage="getList"
      :isLoading="loading" :slotKey="['proxy_name', 'business_data_table_name']" :items="desserts">
      <template v-slot:item.proxy_name="{ item }">
        {{ INT(item.proxy_name) }}
      </template>

      <template v-slot:item.business_data_table_name="{ item }">
        {{ item.business_data_table_name }}
      </template>

      <template v-slot:item.actions="{ item }">
        <menu-list @handleClick="handleClick($event, item)" :list="menulist">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
              'view-approval-business-type',
              'edit-approval-business-type',
              'delete-approval-business-type',
            ]">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { getStaffListForFilter } from "@/service/api/autoComplete.js"
import { required } from "vuelidate/lib/validators"
import { approvertypeList, delApprovertype } from "@/service/api/approvertype"
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      allList: [],
      desserts: [],
    }
  },
  validations: {},
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_The_name_of_the"),
          align: "start",
          sortable: false,
          value: "proxy_name",
        },
        {
          text: this.$t("label_table_name"),
          align: "start",
          sortable: false,
          value: "business_data_table_name",
        },
        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          type: "view",
          show: this.hasBtn("view-approval-business-type"),
          // show: true,
        },
        {
          name: this.$t("label_Edit"),
          type: "edit",
          show: this.hasBtn("edit-approval-business-type"),
          // show: true,
        },
        {
          name: this.$t("label_delete"),
          type: "del",
          show: this.hasBtn("delete-approval-business-type"),
          // show: true,
        },
      ]
    },
  },
  beforeDestroy() {
    this.$ls.remove("staffList")
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    async $route(val) {
      if (val.name == "approvertype") {
        await this.getList(this.paginationOptions)
      }
    },
  },
  async mounted() {
    this.loading = true
    await this.getdropDownList()
    await this.getList(this.paginationOptions)
    this.loading = false
  },
  methods: {
    async getdropDownList() {
      const res = await getStaffListForFilter({
        org_level_uuid: this.$store.state.currentCompany,
      })
      if (res.code == 200) {
        this.allList = res.data
      }
    },
    async getList(obj) {
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.paginationOptions.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.paginationOptions.cpage--
      if (obj) {
        this.paginationOptions = obj
      }
      this.loading = true
      const res = await approvertypeList({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.paginationOptions.totalcount = res.totalcount
        this.paginationOptions.totalpage = res.totalpage
      }
      this.loading = false
    },
    /**
     * @description: 进入详情
     * @param {index} 点的第几个menu
     * @param {item} 点的整条数据
     * @return:
     * @author: lwq
     */
    handleClick({ item, index }, obj) {
      if (item.type == "view") {
        // this.$store.commit('set_subPage_name', obj.proxy_name)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", true)
        this.$router.push({
          name: "detailApprovertype",
          params: {
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == "edit") {
        // this.$store.commit('set_subPage_name', obj.proxy_name)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", false)
        this.$router.push({
          name: "detailApprovertype",
          params: {
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == "del") {
        this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
          .then(async () => {
            const del = await delApprovertype({
              uuid: obj.uuid,
            })
            if (del.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
              if (
                this.desserts.length === 1 &&
                this.paginationOptions.cpage > 1
              ) {
                this.paginationOptions.cpage--
              }
              await this.getList()
            }
          })
          .catch(() => { })
      }
    },
  },
}
</script>

<style scoped></style>
